import { Box, LinearProgress, Stack, styled } from '@mui/material';
import React from 'react';
import { AppFrameTitle } from './AppFrame';


interface PageProps {
  title?: string;
  addPadding?: boolean;
  loading?: boolean;
}

const LoadingContainer = styled('div')({
  height: 4,
});

const AppPage: React.FC<PageProps> = ({ children, title, addPadding = true, loading }) => {
  return (
    <Stack direction="column" flex={1} sx={{ minHeight: 'calc(100vh - 64px)' }}>
      <LoadingContainer>
        {
          loading ? <LinearProgress color="secondary" /> : null
        }
      </LoadingContainer>
      {
        title ? <AppFrameTitle title={title} /> : null
      }
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, p: addPadding ? 2 : 0 }}>
        {children}
      </Box>
    </Stack>
  );
}

export default AppPage;